module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs_dhx_material/menu-down.svg?34bd6069c9f08bb444c86b8d099a000e";